const ADVERT_LIST_BY_DATE_INIT_URL = '/advert/list-by-date/init';
const ADVERT_LIST_BY_SERVICE_INIT_URL = '/advert/list-by-service/init';
const ADVERT_LIST_BY_DATE_LOAD_MORE_URL = '/advert/list-by-date/load-more';
const ADVERT_LIST_BY_SERVICE_LOAD_MORE_URL = '/advert/list-by-service/load-more';

const API_ADVERT_LIST_BY_DATE_NAME = 'apiAdvertListByDate';
const API_ADVERT_LIST_BY_SERVICE_NAME = 'apiAdvertListByService';

export {
  ADVERT_LIST_BY_DATE_INIT_URL,
  ADVERT_LIST_BY_SERVICE_INIT_URL,
  ADVERT_LIST_BY_DATE_LOAD_MORE_URL,
  ADVERT_LIST_BY_SERVICE_LOAD_MORE_URL,

  API_ADVERT_LIST_BY_DATE_NAME,
  API_ADVERT_LIST_BY_SERVICE_NAME,
};
